import "./index.css";
import React from "../../../_snowpack/pkg/react.js";
const NumberInput = ({...args}) => {
  return /* @__PURE__ */ React.createElement("input", {
    type: "number",
    ...args
  });
};
export default NumberInput;
